import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';
import { TryCatchStmt } from '@angular/compiler';

import { UtilesService } from './utiles.service';
import { Visita } from '../Models/Visita';
import { ViajeVisita } from '../Models/ViajeVisita';
import { Resultado } from '../Models/Resultado';
import { ViajeDetalle } from '../Models/ViajeDetalle';
@Injectable()
export class VisitaService {

  constructor(

    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtiene una lista de visita por compañia
   * @param compania Codigo de la compañia
   */
  ObtenerVisitas(compania: string): Observable<Visita[]> {

    try {

      let url = this._utiles.getURL("visita/visitaLista/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <Visita[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene las visitas que han sido procesadas o abortadas en las fechas establecidas
   * @param compania Codigo de la compañia
   * @param fechaInicio Fecha inicio
   * @param fechaFin fecha fin
   */
  ObtenerVisitasProcesado(compania: string, fechaInicio: Date, fechaFin: Date): Observable<Visita[]> {

    try {

      let url = this._utiles.getURL("visita/visitaListaprocesado/" + compania + "/" + fechaInicio + "/" + fechaFin);


      return this._http.get(url).map((response: Response) => {
        return <Visita[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   *  TRAE UNA VISITA Y UNA LISTA DE TAREAS, con el estado de la visita sea activo o asignado
   * @param compania Codigo de la compañia
   * @param idVisita Codigo de la visita
   */
  ObtenerVisitaListaTareas(compania: string, idVisita: string): Observable<Visita> {

    try {

      let url = this._utiles.getURL("visita/visitaListaActivo/" + compania + '/' + idVisita);


      return this._http.get(url).map((response: Response) => {
        return <Visita>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Guarda la visita
   * @param visita Objeto de tipo visita
   */
  public GuardarRegistro(visita: Visita): Observable<Resultado> {

    try {

      let params = JSON.stringify(visita);

      let url = this._utiles.getURL("visita/");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;

      return this._http.post(url, visita, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Guarda el registro de ViajeVisita
   * @param viajeVisita Objeto de tipo ViajeVisita
   * Guarda la visita para ser asignada a un viaje o crear uno nuevo
   */
  public GuardarRegistroViajeVisita(viajeVisita: ViajeVisita[]) {

    try {

      let params = JSON.stringify(viajeVisita);

      let url = this._utiles.getURL("viajevisita/viajevisita");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;

      return this._http.post(url, viajeVisita, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }


  /**
   * Elimina la tarea si todavia no esta asignada
   * @param compania Codigo de la compañia
   * @param idVisita Codigo de la visita
   * @param idTarea Codigo de la tarea
   */
  EliminarTarea(compania: string, idVisita: string, idTarea: string): Observable<Resultado> {

    try {

      let url = this._utiles.getURL("visita/borrarTarea/" + compania + '/' + idVisita) + '/' + idTarea;


      return this._http.get(url).map((response: Response) => {
        return <Resultado>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene un detalle del viaje referente a la fecha que se escogio en el calendario
   * @param compania Codigo de la compañia
   * @param fechaInicio Fecha la cual se selecciona del calendario
   */
  ObtenerVisitasCalendario(compania: string, fechaInicio: string): Observable<ViajeDetalle[]> {

    try {

      let url = this._utiles.getURL("visita/visitacalendariolista/" + compania + "/" + fechaInicio);


      return this._http.get(url).map((response: Response) => {
        return <ViajeDetalle[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  ObtenerVisitasLiberar(compania: string, idUsuario:string): Observable<Visita[]> {

    try {

      let url = this._utiles.getURL("visita/visitasLiberar/" + compania+ "/"+ idUsuario);


      return this._http.get(url).map((response: Response) => {
        return <Visita[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

/**
 * Para tranferir el paquete de visita de un usuario a otro usuario con el estado liberar
 * @param viajeVisita 
 */
  public GuardarRegistroViajeVisitaTransferirPaquete(viajeVisita: ViajeVisita[]) {

    try {

      let params = JSON.stringify(viajeVisita);

      let url = this._utiles.getURL("viajevisita/viajeVisitaTranferirPaquete");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;

      return this._http.post(url, viajeVisita, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }

}

